import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function TopsIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M29.7967 6.7188L23.3966 3.1188C23.2595 3.0414 23.1023 3 22.9432 3H8.3146C8.15551 3 8.00009 3.0414 7.86112 3.1188L1.46112 6.7188C1.0954 6.924 0.919859 7.3488 1.03506 7.7466L2.86363 14.0466C3.00078 14.5146 3.49083 14.7882 3.96443 14.673L6.48603 14.0538V29.1C6.48603 29.5968 6.89563 30 7.40032 30H23.8574C24.3621 30 24.7717 29.5968 24.7717 29.1V14.0538L27.2915 14.673C27.7633 14.7936 28.257 14.5146 28.3923 14.0466L30.2209 7.7466C30.3379 7.3488 30.1624 6.924 29.7967 6.7188ZM26.8783 12.7146L24.0787 12.027C23.8063 11.9604 23.5155 12.0216 23.2943 12.1908C23.073 12.3618 22.9432 12.6228 22.9432 12.9V28.2H8.3146V12.9C8.3146 12.6228 8.1866 12.3636 7.96351 12.1926C7.74043 12.0216 7.44969 11.9586 7.17906 12.0288L4.37952 12.7164L2.98981 7.932L8.55781 4.8H22.6999L28.2661 7.9302L26.8783 12.7146Z"
        fill="currentColor"
      />
      <path
        d="M19.286 3C18.7813 3 18.3717 3.4032 18.3717 3.9C18.3717 5.3886 17.1411 6.6 15.6289 6.6C14.1167 6.6 12.886 5.3886 12.886 3.9C12.886 3.4032 12.4765 3 11.9718 3C11.4671 3 11.0575 3.4032 11.0575 3.9C11.0575 6.3804 13.1091 8.4 15.6289 8.4C18.1505 8.4 20.2003 6.3804 20.2003 3.9C20.2003 3.4032 19.7907 3 19.286 3Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
